const Config = {
   API_URL:'https://portal-server.smart-school.com.ua/api/v1/',
   LOCAL_URL:'http://local-portal.smart-school.com.ua/web/api/v1/'
}

export default Config